import type { Player } from './types';

// ── v1 Legacy: credits / premium (kept for migration & profileSync) ──

export function addCredits(player: Player, amount: number, now: number = Date.now()): Player {
  if (amount === 0) return player;
  return { ...player, credits: player.credits + amount, updatedAt: now };
}

export function spendCredits(
  player: Player,
  amount: number,
  now: number = Date.now(),
): { player: Player; ok: boolean } {
  if (amount <= 0) return { player, ok: true };
  if (player.credits < amount) return { player, ok: false };
  return {
    player: { ...player, credits: player.credits - amount, updatedAt: now },
    ok: true,
  };
}

export function addPremium(player: Player, amount: number, now: number = Date.now()): Player {
  if (amount === 0) return player;
  return { ...player, premium: player.premium + amount, updatedAt: now };
}

export function spendPremium(
  player: Player,
  amount: number,
  now: number = Date.now(),
): { player: Player; ok: boolean } {
  if (amount <= 0) return { player, ok: true };
  if (player.premium < amount) return { player, ok: false };
  return {
    player: { ...player, premium: player.premium - amount, updatedAt: now },
    ok: true,
  };
}

// ── v2 Economy: cleanCode / corruptedData / neonGems ──

export function addCorruptedData(player: Player, amount: number, now: number = Date.now()): Player {
  if (amount === 0) return player;
  return { ...player, corruptedData: (player.corruptedData ?? 0) + amount, updatedAt: now };
}

export function spendCorruptedData(
  player: Player, amount: number, now: number = Date.now(),
): { player: Player; ok: boolean } {
  if (amount <= 0) return { player, ok: true };
  const cur = player.corruptedData ?? 0;
  if (cur < amount) return { player, ok: false };
  return { player: { ...player, corruptedData: cur - amount, updatedAt: now }, ok: true };
}

export function addCleanCode(player: Player, amount: number, now: number = Date.now()): Player {
  if (amount === 0) return player;
  return { ...player, cleanCode: (player.cleanCode ?? 0) + amount, updatedAt: now };
}

export function spendCleanCode(
  player: Player, amount: number, now: number = Date.now(),
): { player: Player; ok: boolean } {
  if (amount <= 0) return { player, ok: true };
  const cur = player.cleanCode ?? 0;
  if (cur < amount) return { player, ok: false };
  return { player: { ...player, cleanCode: cur - amount, updatedAt: now }, ok: true };
}

export function addNeonGems(player: Player, amount: number, now: number = Date.now()): Player {
  if (amount === 0) return player;
  return { ...player, neonGems: (player.neonGems ?? 0) + amount, updatedAt: now };
}

export function spendNeonGems(
  player: Player, amount: number, now: number = Date.now(),
): { player: Player; ok: boolean } {
  if (amount <= 0) return { player, ok: true };
  const cur = player.neonGems ?? 0;
  if (cur < amount) return { player, ok: false };
  return { player: { ...player, neonGems: cur - amount, updatedAt: now }, ok: true };
}
